import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 引入全局css
import '@/styles/index.scss';
import '@/styles/element-variables.scss'
import '@/styles/pageation.scss';




// 按需引入vue-awesome图标
// import Icon from 'vue-awesome/components/Icon';
// import 'vue-awesome/icons/chart-bar.js';
// import 'vue-awesome/icons/chart-area.js';
// import 'vue-awesome/icons/chart-pie.js';
// import 'vue-awesome/icons/chart-line.js';
// import 'vue-awesome/icons/align-left.js';
// // 全局注册图标
// Vue.component('icon', Icon);

// 适配flex
// import '@/utils/flexible.js';

import global from './utils/global' // 全局方法
Vue.use(global)

import Cookies from 'js-cookie'
Vue.prototype.$Cookies = Cookies


Vue.use(ElementUI)

import { longClickDirective } from 'vue-long-click'
const longClickInstance = longClickDirective({delay: 400, interval: 50})
Vue.directive('longclick', longClickInstance)


/* 引入aos动画库相关文件 */
import AOS from 'aos'
import 'aos/dist/aos.css'
/* aos动画初始化 */
AOS.init({
  throttleDelay: 190,
  delay: 2, //延迟时间值从0到3000 ，步长为50毫秒，
  duration: 800, //持续时间,值从0到3000，步长为50毫秒
  easing: "ease-out-cubic", // AOS动画的默认缓动
  offset: 60,
  // once: false, //动画是否应该只发生一次
  // mirror: false, //当滚动经过元素时，是否应该将其动画化
  // anchorPlacement: "top-bottom", //定义元素相对于窗口的哪个位置应该触发动画
});

import animated from 'animate.css'
Vue.use(animated)

import sizeMixin from '@/utils/sizeMixin';//混入-浏览器窗口监听
Vue.mixin(sizeMixin);


Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: (h) => h(App),
  beforeCreate(){
    Vue.prototype.$bus = this;
  }
}).$mount('#app');
